import { Injectable } from '@angular/core';
import { Filtro } from '../models/filtro';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Transportadora } from '../models/transportadora';

@Injectable({
  providedIn: 'root'
})
export class TransportadoraService {

  constructor(private globalService: GlobalService, private http: HttpClient) {
  }

  consultarTransportadoras() {
    return this.http.get<any>(globals.apiUrl + '/api/Transportadora/Listar');
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Transportadora/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(transportadora: Transportadora) {
    return this.http.post(globals.apiUrl + '/api/Transportadora/Salvar', transportadora);
  }


  consultarTransportadorasComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoPesquisa, pesquisa?: string, situacao?: number) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoPesquisa', tipoPesquisa !== undefined && tipoPesquisa !== null ? tipoPesquisa : '')
      .set('pesquisa', pesquisa ? pesquisa : '')
      .set('situacao', situacao ? situacao.toString() : '0');

    return this.http.get<any>(globals.apiUrl + '/api/Transportadora/ListaPag',
      {
        params: parametros
      });
  }

}
